import { useRouter } from 'next/router';

import { Routes } from 'constants/routes.constants';
import { useDeepCompareEffect } from 'hooks/useDeepCompareEffect';
import { useAccount } from 'queries/accounts/useAccount';

// Don't show the onboarding on these routes
const EXCLUDE_ROUTES: Array<string> = [
  Routes.PrivacyPolicy,
  Routes.TermsOfService,
  Routes.AccountOnboarding,
];

// This is not a hook since we need it on every page and already need most of the providers loaded
const OnboardedCheck = () => {
  const { account, isSignedIn, isLoading, isNotFound } = useAccount();
  const router = useRouter();

  useDeepCompareEffect(() => {
    if (
      !isLoading &&
      isSignedIn &&
      !account &&
      !EXCLUDE_ROUTES.includes(router.asPath) &&
      isNotFound
    ) {
      router.replace(Routes.AccountOnboarding);
    }
  }, [router.asPath, account, isSignedIn, isLoading]);

  return null;
};

export default OnboardedCheck;
